import { useEffect, useState } from 'react'
import { supabase } from '../supabaseClient'

import './PlanningPage.css'

export default function PlanningPage({ currentUser }) {

  const [recentWins, setRecentWins] =
    useState([])

    const [frictionTasks, setFrictionTasks] =
  useState([])

  const [needsAttention, setNeedsAttention] =
  useState([])

  const [pausedTasks, setPausedTasks] =
  useState([])

  const [inboxItems, setInboxItems] = useState([])

  useEffect(() => {
    if (!currentUser?.id) {
      setInboxItems([])
      setRecentWins([])
      setFrictionTasks([])
      setNeedsAttention([])
      setPausedTasks([])
      return
    }

    fetchInboxItems()
    fetchRecentWins()
    fetchRecurringFriction()
    fetchNeedsAttention()
    fetchPausedTasks()
  }, [currentUser])

  async function fetchInboxItems() {
  const { data, error } = await supabase
    .from('inbox')
    .select(`
      id,
      user_id,
      name,
      notes,
      created_at
    `)
    .eq('user_id', currentUser.id)
    .is('processed_at', null)
    .is('deleted_at', null)
    .order('created_at', {
      ascending: true
    })
    .limit(5)

  if (error) {
    console.error(error)
    return
  }

  setInboxItems(data || [])
}
  
  async function fetchRecentWins() {
    const { data, error } = await supabase
      .from('task_events')
      .select(`
        id,
        created_at,
        metadata
      `)
      .eq('user_id', currentUser.id)
      .eq('event_type', 'completed')
      .order('created_at', {
        ascending: false
      })
      .limit(5)

    if (error) {
      console.error(error)
      return
    }

    setRecentWins(data || [])
  }

  async function fetchRecurringFriction() {
    const { data, error } = await supabase
        .from('task_events')
        .select(`
        metadata,
        task_id
        `)
        .eq('user_id', currentUser.id)
        .eq('event_type', 'skipped')

    if (error) {
        console.error(error)
        return
    }

    // Count skips by task name
    const counts = {}

    data.forEach(event => {
        const name =
        event.metadata?.taskName

        if (!name) return

        counts[name] =
        (counts[name] || 0) + 1
    })

    // Convert to array
    const sorted = Object.entries(counts)
        .map(([name, count]) => ({
        name,
        count
        }))
        .sort((a, b) =>
        b.count - a.count
        )
        .slice(0, 5)

    setFrictionTasks(sorted)
    }


async function fetchNeedsAttention() {
  const sevenDaysAgo = new Date()
  sevenDaysAgo.setDate(
    sevenDaysAgo.getDate() - 7
  )

  const { data, error } = await supabase
    .from('tasks')
    .select(`
      id,
      name,
      created_at,
      status_id,
      is_completed,
      is_hidden
    `)

    .eq('user_id', currentUser.id)
    .lt(
      'created_at',
      sevenDaysAgo.toISOString()
    )

    .eq('is_completed', false)

    .eq('is_hidden', false)

    .in('status_id', [1, 2, 3, 4, 5])

    .order('created_at', {
      ascending: true
    })

    .limit(5)

  if (error) {
    console.error(error)
    return
  }

  setNeedsAttention(data || [])
}

async function fetchPausedTasks() {
  const { data, error } = await supabase
    .from('tasks')
    .select(`
      id,
      name,
      status_id,
      created_at
    `)
    .eq('user_id', currentUser.id)
    .in('status_id', [3, 5, 9])
    .eq('is_completed', false)
    .eq('is_hidden', false)
    .order('created_at', {
      ascending: true
    })
    .limit(5)

  if (error) {
    console.error(error)
    return
  }

  setPausedTasks(data || [])
}   


  async function convertInboxToTask(item) {
      if (!currentUser?.id) return
      
  const { data, error } = await supabase
    .from('tasks')
    .insert([
      {
        name: item.name,
        notes: item.notes,
        user_id: item.user_id,
        status_id: 10,
      }
    ])
    .select()
    .single()

  if (error) {
    console.error("Task insert failed:", error)
    alert("Task insert failed. Check console.")
    return
  }

  const { error: inboxError } = await supabase
    .from('inbox')
    .update({
      processed_at: new Date().toISOString(),
      converted_to_type: 'task',
      converted_to_id: data.id
    })
    .eq('id', item.id)

  if (inboxError) {
    alert("Inbox update failed. Check console.")
    return
  }

  fetchInboxItems()
}

  async function deleteInboxItem(id) {
    await supabase
      .from('inbox')
      .update({
        deleted_at: new Date()
      })
      .eq('id', id)

    fetchInboxItems()
  }

  {/*RETURN CODE*/}
  return (

    <div className="planning-page">

      <h1 className="planning-title">
        Planning & Review
      </h1>

      <p className="planning-subtitle">
        Reflect, review patterns, and plan intentionally.
      </p>

      <div className="planning-grid">
        {/*PLANNING CARD*/}
        <section className="planning-card">

          <h2>Inbox Processing</h2>

          {inboxItems.length === 0 ? (
            <p>Inbox clear. Nice work.</p>
          ) : (
            <ul className="planning-list">
              {inboxItems.map(item => (
                <li key={item.id}>

                  <strong>{item.name}</strong>

                  {item.notes && (
                    <p>{item.notes}</p>
                  )}

                  <div>
                    <button
                      onClick={() =>
                        convertInboxToTask(item)
                      }
                    >
                      Convert to Task
                    </button>

                    <button
                      onClick={() =>
                        deleteInboxItem(item.id)
                      }
                    >
                      Delete
                    </button>
                  </div>

                </li>
              ))}
            </ul>
          )}

        </section>

        {/* RECENT WINS */}

        <section className="planning-card">

          <h2>Recent Wins</h2>

          {recentWins.length === 0 ? (

            <p>
              No recent completions yet.
            </p>

          ) : (

            <ul className="planning-list">

              {recentWins.map(event => (

                <li key={event.id}>

                  ✅ {event.metadata?.taskName}

                </li>

              ))}

            </ul>

          )}

        </section>


  {/* RECURRING FRICTION */}

        <section className="planning-card">

          <h2>Recurring Friction</h2>

          <p>
            {frictionTasks.length === 0 ? (

                <p>
                    No recurring friction detected.
                </p>

                ) : (

                <ul className="planning-list">

                    {frictionTasks.map(item => (

                    <li key={item.name}>

                        ⚠️ {item.name}
                        <br />

                        <small>
                        Skipped {item.count} times
                        </small>

                    </li>

                    ))}

                </ul>

                )}
          </p>

        </section>


 {/* NEEDS ATTENTION */}

        <section className="planning-card">

          <h2>Needs Attention</h2>

          <p>
            {needsAttention.length === 0 ? (

            <p>
                Nothing currently needs attention.
            </p>

            ) : (

            <ul className="planning-list">

                {needsAttention.map(task => (

                <li key={task.id}>

                    👀 {task.name}

                </li>

                ))}

            </ul>

            )}
          </p>

        </section>


 {/* PAUSED */}

        <section className="planning-card">

          <h2>Paused & Later</h2>

          <p>
            {pausedTasks.length === 0 ? (

            <p>
                No paused or later tasks right now.
            </p>

            ) : (

            <ul className="planning-list">

                {pausedTasks.map(task => (

                <li key={task.id}>

                    🌱 {task.name}

                </li>

                ))}

            </ul>

            )}
          </p>

        </section>

      </div>

    </div>
  )
}